import { $ } from '../utils/jquery.js';

export function freeze() {
  const h = $("html");

  if (h.css("position") !== "fixed") {
    const top = h.scrollTop() ? h.scrollTop() : $("body").scrollTop();

    if (window.innerWidth > h.width()) {
      h.css("overflow-y", "scroll");
    }

    h.css({
      position: "fixed",
      top: -top,
    });
  }
}

export function unfreeze() {
  const h = $("html");

  if (h.css("position") === "fixed") {
    h.css("position", "static");

    $("html, body").scrollTop(-parseInt(h.css("top"), 10));
    h.css({
      position: "",
      top: "",
      "overflow-y": "",
    });
  }
}
